module.exports = __webpack_public_path__ + "static/media/integromat.534340f5.svg";